export async function refreshApprovedWorkoutActivities({ result, fetchActivity, setActivities }) {
  const ids = Array.isArray(result?.references?.updated_future_activity_ids)
    ? result.references.updated_future_activity_ids.map(String)
    : [];
  if (ids.length === 0 || !fetchActivity || !setActivities) return [];
  const settled = await Promise.allSettled(ids.map(id => fetchActivity(id)));
  const refreshed = settled.filter(item => item.status === 'fulfilled' && item.value).map(item => item.value);
  if (refreshed.length === 0) return [];
  const byId = new Map(refreshed.map(activity => [String(activity._id), activity]));
  setActivities(previous => previous.map(activity => byId.get(String(activity._id)) || activity));
  return refreshed;
}
